import { createFileRoute } from '@tanstack/react-router'

import { NnppImportNewPage } from '@/src/pages/nnpp/imports/NnppImportNewPage'

export const Route = createFileRoute('/nnpp/imports/new')({
  component: NnppImportNewPage,
  staticData: { layout: { enableScrolling: true, showSearchBar: false } },
})
